module.exports = __webpack_public_path__ + "img/9788936456016.4366bea4.jpg";